module.exports = __webpack_public_path__ + "static/media/shot  -01.2aac8308.webp";